<!-- eslint-disable max-len -->
<template>
  <div v-show="showContainerDataset">
    <div
      class="data-page-header"
      style="height: 126px">
      <div class="d-flex">
        <img
          class="back-to-list-apps"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/joana')"
        >
        <h3>{{ dataGroup ? dataGroup.name : '' }}</h3>
      </div>
      <div class="d-flex">
        <j-input
          v-model="filter_data"
          :error-required="false"
          placeholder="Search"
          class="text-search-data"/>
        <i
          id="addPopover"
          class="fa fa-lg fa-plus font-weight-bold cursor-pointer m__t--10 m__l--10"/>
      </div>
      <!-- <div class="action-select-data">
        <span @click="selectAll">Select All</span>
        <span
          class="m__l--5"
          @click="unselectAll">Unselect All</span>
      </div> -->
    </div>
    <div
      v-if="modeDetail"
      class="data-page-header-full" />

    <div class="data-left-content">
      <div
        v-for="(item, index) in datasetList"
        :key="index"
        :class="{ 'active': dataset_id === item.id }"
        class="list-data-content">
        <!-- <j-checkbox
          :checked="checkSelected(item.id)"
          class="checkbox-oos tick-import-data"
          @input="selectData($event, item)"
        /> -->
        <div
          class="item-data-manager"
          @click="switchForm(item)">
          <img
            :src="require('@/assets/logo/dataset-icon-table.svg')"
            class="m__r--10"
            height="19">
          <div class="info__list-data-content">
            <div class="title__list-data-content">{{ item.name ? item.name : 'No Name' }}</div>
            <div class="id__list-data-content">{{ item.id }}</div>
          </div>
          <div class="size__list-data-content">{{ item.size }}</div>
        </div>
      </div>
    </div>

    <div
      v-if="modeDetail"
      class="data-right-update-content">
      <j-dataset-page-detail
        :dataset-id="datasetId"
        :find-record="findRecord"
        :key="datasetId"
        @reload="reloadAfterDelete"/>
    </div>
    <div
      v-else
      class="data-right-create-content">
      <img
        src="@/assets/logo/dataset.svg"
        height="200">
      <h4 class="m__t--20 m__b--20">No Dataset Selected</h4>
      <span
        class="btn__list-data-content"
        @click="$refs.appTypeFormDataModal.show()">
        Create Dataset
      </span>
    </div>

    <b-modal
      ref="appTypeFormDataModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE DATASET</div>
      <div class="container-type-list-options">
        <div
          :class="typeMode === 'blank' ? 'option-active' : ''"
          class="container-option"
          @click="typeMode = 'blank'">
          <img
            v-if="typeMode === 'blank'"
            src="@/assets/icon/blank-blue.png">
          <img
            v-else
            src="@/assets/icon/blank.png">
          <span class="text-option">Create New Blank</span>
        </div>
        <div
          :class="typeMode === 'code' ? 'option-active' : ''"
          class="container-option">
          <img
            v-if="typeMode === 'code'"
            src="@/assets/icon/code-blue.png">
          <img
            v-else
            src="@/assets/icon/code.png">
          <span class="text-option">Execute Code</span>
        </div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="$refs.appTypeFormDataModal.hide()">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="nextStep">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appCodeFormDataModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE DATASET</div>
      <b-row>
        <b-col md="8">
          <label> JSON </label>
        </b-col>
        <b-col
          md="3"
          class="p__r--1 m__t--3">
          <small class="pull-right">Dark Mode</small>
        </b-col>
        <b-col
          md="1"
          class="p__l--1">
          <j-toggle v-model="darkMode"/>
        </b-col>
      </b-row>
      <div class="scroll-script">
        <prism-editor
          v-model="jsonData"
          :highlight="highlighter"
          :line-numbers="true"
          :class="{'dark-mode' : darkMode}"
          class="my-editor"
        />
      </div>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCodeForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createCodeData">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appAddFormDataModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE DATASET</div>
      <b-form-group :class="{'error-input' : $v.dataset_name.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.dataset_name.$model"
          :error-required="$v.dataset_name.$error"
          :max-length="255"
          placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_form"/>
      </b-form-group>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCreateForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createFormData">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appImportFormDataModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">IMPORT</div>
      <div
        v-if="dropboxImportShow"
        class="dropbox-oos">
        <input
          type="file"
          multiple
          class="input-file"
          @change="handleFileUpload($event.target.files)">
        <img :src="require('@/assets/form-data/file-dropbox.png')">
        <div class="label-dropbox">Drop your file here, or <span>browse</span></div>
        <div class="label-support-dropbox">Support : JSON</div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closeImportForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <div
      :class="{'show-container-floating-data-manager' : showProperties,
               'hide-container-floating-data-manager' : !showProperties,
               'container-floating-data-manager-long' : !is_sidebar_minimized}"
      class="container-floating-data-manager">
      <div class="count-data-selected">{{ selected_rows.length }}</div>
      <div class="label-data-selected">Dataset <br> Selected</div>
      <div class="btn-export-data">
        <img :src="require('@/assets/icon/export-data-white.svg')"> Export
      </div>
      <div
        class="close-data-selected"
        @click="unselectAll">X</div>
    </div>

    <b-popover
      ref="addPopoverRef"
      :show.sync="addPopoverShow"
      target="addPopover"
      placement="bottom">
      <div
        class="add-data-manager"
        @click="$refs.appAddFormDataModal.show(); addPopoverShow = false">
        <div class="w__10"><img :src="require('@/assets/form-data/new-blank-small.png')"></div>
        <div class="m__l--10">Create New Blank</div>
      </div>
      <!-- <div
        class="add-data-manager"
        @click="$refs.appCodeFormDataModal.show(); addPopoverShow = false">
        <div class="w__10"><img :src="require('@/assets/form-data/execute-code-small.png')"></div>
        <div class="m__l--10">Execute Code</div>
      </div> -->
      <div
        class="add-data-manager"
        style="opacity: 0.3">
        <div class="w__10"><img :src="require('@/assets/form-data/execute-code-small.png')"></div>
        <div class="m__l--10">Execute Code</div>
      </div>
      <!-- <div
        class="add-data-manager"
        @click="$refs.appImportFormDataModal.show(); addPopoverShow = false; dropboxImportShow = true">
        <div class="w__10"><img :src="require('@/assets/form-data/import-small.png')"></div>
        <div class="m__l--10">Import</div>
      </div> -->
      <div
        class="add-data-manager"
        style="opacity: 0.3">
        <div class="w__10"><img :src="require('@/assets/form-data/import-small.png')"></div>
        <div class="m__l--10">Import</div>
      </div>
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapActions, mapState, mapMutations } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import jDatasetPageDetail from '@/views/joanadb/dataset/jDatasetPageDetail';
import axios from 'axios';
import Vue from 'vue';

import { highlight, languages } from 'prismjs/components/prism-core';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  /* eslint-disable vue/name-property-casing */
  name: 'jDataset',
  components: {
    jDatasetPageDetail,
    PrismEditor,
  },
  data() {
    return {
      filter_data: '',
      jsonData: '',
      darkMode: false,

      dataGroup: null,
      modeDetail: false,
      datasetId: null,
      dataset_name: '',
      typeMode: '',
      datasetList: [],
      selected_rows: [],
      addPopoverShow: false,
      dropboxImportShow: false,
      file: null,
      showContainerDataset: false,
      findRecord: false,
    };
  },
  computed: {
    ...mapState('jStoreJoana', ['dataset_list', 'dataset_id', 'record_changed']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    showProperties() {
      return this.selected_rows.length > 0;
    },
  },
  watch: {
    dataset_name(val) {
      if (val) {
        const regexSymbol = /[^\w\s]/g;
        setTimeout(() => {
          this.dataset_name =
            val.toLowerCase()
              .replace(regexSymbol, '')
              .replace(' ', '_');
        }, 1);
      }
    },

    filter_data(val) {
      this.datasetList = this.dataset_list.filter(app => app.name.toUpperCase().includes(val.toUpperCase()) || app.id.toUpperCase().includes(val.toUpperCase()));
    },

    record_changed() {
      this.findRecordDataset();
    },
  },
  created() {
    this.getDataGroup();
  },
  methods: {
    ...mapMutations('jStoreJoana', ['setDataset']),
    ...mapActions('jStoreJoana', ['getListDataGroup', 'getListDatasetByGroup', 'createDatasetByGroup', 'countRecordDataset']),

    getDataGroup() {
      const dataFilter = { id: this.$route.params.id };
      const req = {
        page: 1,
        limit: 10,
        sort: { updated_at: -1 },
        filter: {
          where_is_and: { id: this.$route.params.id },
        },
        filter_operator: 'and',
      };
      this.getListDataGroup(req).then((res) => {
        this.getDatasetList();
        if (res.data && res.data.length > 0) {
          const detailGroup = res.data.find(f => f.id === this.$route.params.id);
          this.dataGroup = detailGroup || null;
        }
      });
    },

    getDatasetList() {
      const req = {
        page: 1,
        limit: 1000000,
        filter: {
          where_is_and: { datasetgroup_id: this.$route.params.id },
        },
        sort: { updated_at: -1 },
        filter_operator: 'and',
      };
      this.getListDatasetByGroup(req).then((res) => {
        this.datasetList = res.data;
        this.showContainerDataset = true;
      });
    },

    switchForm(data) {
      this.modeDetail = true;
      this.datasetId = data.id;
      this.setDataset(data);
      this.findRecordDataset();
    },

    findRecordDataset() {
      const param = { dataset_id: this.datasetId };
      this.countRecordDataset(param).then((resp) => {
        this.findRecord = !!(resp.data && resp.data.count > 0);
      });
    },

    reloadAfterDelete() {
      this.modeDetail = false;
      this.getDatasetList();
    },

    selectData(data, item) {
      const exsist = this.selected_rows.find(f => f.id === item.id);
      if (exsist) {
        const indexDeleted = this.selected_rows.findIndex(e => e.id === item.id);
        this.selected_rows.splice(indexDeleted, 1);
      } else {
        this.selected_rows.push(item);
      }
    },

    selectAll() {
      this.selected_rows = [...this.dataset_list];
    },

    unselectAll() {
      this.selected_rows = [];
    },

    checkSelected(id) {
      const findID = this.selected_rows.find(f => f.id === id);
      return !!findID;
    },

    exportData() {
      this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
      const token = Vue.ls.get('Token');
      const gateUrl = localStorage.getItem('gateUrl');
      const url = `${gateUrl}nocode/joana/dataset/export`;
      const params = {
        id: this.selected_rows.map(val => val.id),
      };

      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
        const data = JSON.stringify(res.data);
        const blob = new Blob([data], { type: 'text/plain' });
        const e = document.createEvent('MouseEvents');
        const a = document.createElement('a');
        a.download = 'dataset.json';
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
      });
    },

    handleFileUpload(file) {
      console.log(file);
      if (file[0].type.includes('json')) {
        this.$swal({
          title: 'IMPORT',
          text: `Are you sure to import file ${file[0].name} ?`,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
            const token = Vue.ls.get('Token');
            const formData = new FormData();
            const gateUrl = localStorage.getItem('gateUrl');
            const url = `${gateUrl}nocode/joana/dataset/import?token=${token}`;

            formData.append('file', file[0]);

            axios.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
            ).then(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Success Import Data');
              this.closeImportForm();
              setTimeout(() => {
                this.getDatasetList();
              }, 500);
            }).catch(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Error Import Data');
            });
          } else {
            this.dropboxImportShow = false;
            setTimeout(() => {
              this.dropboxImportShow = true;
            }, 100);
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'File not support');
      }
    },

    closeImportForm() {
      this.$refs.appImportFormDataModal.hide();
      this.dropboxImportShow = false;
    },

    highlighter(code) {
      return highlight(code, languages.js); // returns html
    },

    nextStep() {
      if (this.typeMode === 'blank') {
        this.$refs.appAddFormDataModal.show();
      } else {
        this.$refs.appCodeFormDataModal.show();
      }
    },

    createCodeData() {
      if (this.jsonData) {
        const param = JSON.parse(this.jsonData);
        this.createDatasetByGroup(param).then((response) => {
          if (!response.error) {
            this.closeCodeForm();
            this.getDatasetList();
            this.switchForm(response.data);
          }
        });
      }
    },

    closeCodeForm() {
      this.jsonData = '';
      this.$refs.appCodeFormDataModal.hide();
    },

    closeCreateForm() {
      this.dataset_name = '';
      this.$refs.appAddFormDataModal.hide();
      setTimeout(() => {
        this.$v.dataset_name.$reset();
      }, 500);
    },

    validateData() {
      this.$v.dataset_name.$touch();
      return this.$v.dataset_name.$error;
    },

    createFormData() {
      if (!this.validateData()) {
        const param = {
          name: this.dataset_name,
          datasetgroup_id: this.$route.params.id,
        };
        this.createDatasetByGroup(param).then((response) => {
          if (!response.error) {
            this.closeCreateForm();
            this.getDatasetList();
            this.switchForm(response.data);
          }
        });
      }
    },
  },
  validations() {
    return {
      dataset_name: { required },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDataset.vue